query GetMmsRequest($id: ID!) {
  mmsRequest(id: $id) {
    id

    insertedAt
    updatedAt

    processedAt

    expiredAt
    scheduledAt

    hostNumber
    remoteNumber

    direction

    status
    errorCode

    displayBody

    remoteNeedDeliveryReceipt

   

    remoteMessagingEnabled
    remoteReferenceId
    remoteCountryCode
    remoteTier

    account {
      id
      name
    }
  }
}
